<template>
  <div v-if="!fetchingJob && job">
    <create-job :clone="job" />
  </div>
  <loading-page v-else />

</template>

<script>
import CreateJob from './CreateJob.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'CloneJob',
  components: { CreateJob },
  data() {
    return {}
  },
  computed: {
    job() { return this.$store.state.jobs.job },
    fetchingJob() { return this.$store.state.jobs.fetchingJob },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.fetchJobByName()
    },
    fetchJobByName() {
      this.$store.dispatch('jobs/fetchJob', this.$route.params.name).catch(err => redirectError(err, this.$router, this.$route.path))
    },
    formatDate(date) {
      return new Date(date).format('YYYY-M-D HH:mm')
    },
  },
}
</script>

<style>

</style>
